import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from './styles'

export const StatusChip = ({ label, variant, className }) => {
  return (
    <Chip $variant={variant} className={className}>
      {label}
    </Chip>
  )
}

StatusChip.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf([
    'operational',
    'active',
    'inactive',
    'published',
    'draft',
    'archived',
    'pending',
    'warning',
    'error',
    'info',
    'maturity-initial',
    'maturity-developing',
    'maturity-defined',
    'maturity-managed',
    'maturity-optimized',
    'public',
    'protected',
    'private',
    'success',
    'primary',
    'secondary',
    'tier1',
    'tier2',
    'tier3',
    'default',
  ]),
  className: PropTypes.string,
}
